import { useLocation } from 'react-router-dom';
import {
  ArticleListFetchConnectorApollo,
  ArticleListFetchOnDemandConnectorApollo,
  ArticleFetchOnDemandConnectorApollo,
} from '@front-activerse/common-components';
import ArticleListContainer from './ArticleListContainer';

const ArticleListPage = ({ consts }) => {
  const location = useLocation();
  const pathname = location.pathname;
  let parts = pathname.split('/');
  let category = parts[2];

  return (
    <ArticleListFetchOnDemandConnectorApollo>
      {(loadArticleList) => (
        <ArticleListFetchConnectorApollo
          categories={consts.categories.filter((cat) => cat !== 'all')}
          category={category === 'all' ? null : category}
          articlesPerPage={consts.articlesPerPage}
          loadArticleList={loadArticleList}
        >
          {({ accessTo, ...articleList }) => {
            return (
              <ArticleFetchOnDemandConnectorApollo>
                {(loadArticle) => (
                  <ArticleListContainer
                    {...articleList}
                    category={category}
                    accessTo={accessTo}
                    loadArticle={loadArticle}
                    loadArticleList={loadArticleList}
                    articlesPerPage={consts.articlesPerPage}
                    truncateLimit={consts.truncateLimit}
                    categories={consts.categories}
                    categoryAsNumber={consts.categoryAsNumber}
                  />
                )}
              </ArticleFetchOnDemandConnectorApollo>
            );
          }}
        </ArticleListFetchConnectorApollo>
      )}
    </ArticleListFetchOnDemandConnectorApollo>
  );
};

export default ArticleListPage;
